import type { FaireProductEntity } from "../../entity_types/product";

export const p_rzugxcmz7n: FaireProductEntity = {
  token: "p_rzugxcmz7n",
  type: "product",
  name: "Rudolph Santa's Sleigh Christmas Building Kit",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/23b0603ec3b1211207811eed121218f92d7aae3a45bc4de236e637f9b4f0fb49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2676bcc4371ddb60495fedc432f6062a3e66097e76a0a0708a9fba96ef0622c6.jpeg",
    "https://cdn.faire.com/fastly/4002e4443c8a76027729d039fd013e53e3736bc3097b3c3e53ecd2f31dfde9f7.jpeg",
    "https://cdn.faire.com/fastly/23850737b917ef9767f131e2a07b9bf6e7645caedf678daa414ac18b01cfe717.jpeg",
    "https://cdn.faire.com/fastly/55da448d748b2270ed277b0741702d0fa0a651f0ca02799b9983f15ef97c97df.jpeg",
    "https://cdn.faire.com/fastly/455f3edd1a582344c6b67b92fc32c77065f7d63ba92d45b7c9e89a0d9f697d9b.jpeg",
    "https://cdn.faire.com/fastly/2300dd7dbd62608ae9bb81f09a05a1c95a50326559d718f592b83e4a47667a1f.jpeg",
    "https://cdn.faire.com/fastly/28c451820b0a24f61681688d76a3eb5d0adfac3783d18cb03f56757f8c7c05bd.jpeg",
  ],
  priceDollars: 22.05,
  description:
    "Rudolph leads Santa’s sleigh in this festive brick-built holiday scene, complete with his glowing red nose and mid-flight pose. Santa sits in a purple sleigh packed with gifts, while clear supports and a snowy base give the illusion of soaring through the sky. With printed details and playful touches, this nostalgic build makes a magical holiday centerpiece for mantels, desks, or shelves.",
  tags: [],
  msrpDollars: 44.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:57.209Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
